import { useSuspenseQuery } from '@tanstack/react-query';
import { downloadsTransformedQueryOptions, latestDownloadsQueryOptions } from '#api/downloads.queries.ts';
import { MainLayout } from '#components/patterns/layouts/main/MainLayout.tsx';
import { DownloadRow } from '../download-row/DownloadRow.tsx';
import { PlatformCard } from '../platform-card/PlatformCard.tsx';
import styles from './DownloadsPage.module.css';

export function DownloadsPage() {
  // Separate hooks rather than useSuspenseQueries: both options share one cache key, and
  // useSuspenseQueries re-renders in a loop when two entries share a key.
  const {
    data: {
      dnclient: { current, all },
    },
  } = useSuspenseQuery(downloadsTransformedQueryOptions);
  const { data: latestData } = useSuspenseQuery(latestDownloadsQueryOptions);

  return (
    <MainLayout header="Downloads">
      <div className="mb-40" key={current.version}>
        <header className="mb-24">
          <h2 className="h4 mb-8">
            <span>v{current.version}</span>
            <span className="ml-8">{current.releaseDate}</span>
          </h2>
          <a href="https://www.defined.net/docs/dnclient-changelog/" className="a p-md" target="_blank">
            Changelog
          </a>
          {', '}
          <a
            href="https://www.defined.net/docs/get-started/dnclient-server/upgrade/"
            className="a p-md"
            target="_blank"
            rel="help"
          >
            Upgrade guide
          </a>
        </header>
        <div className={styles.DownloadsPage_platformCards}>
          <PlatformCard os="Linux" platforms={latestData.Linux} />
          <PlatformCard os="macOS" platforms={latestData.macOS} />
          <PlatformCard os="Windows" platforms={latestData.Windows} />
          <PlatformCard os="Mobile" platforms={latestData.Mobile} />
          <PlatformCard os="Other" platforms={latestData.Other} />
        </div>
      </div>
      <div className={styles.DownloadsPage_previousVersions}>
        <h2 className="h4">All versions and architectures</h2>
        {all.map((d) => (
          <DownloadRow key={d.version} version={d.version} date={d.date} downloads={d.downloads} />
        ))}
      </div>
    </MainLayout>
  );
}
